module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [_c('el-aside', {
    staticClass: "aside",
    class: {
      'no-sub': _vm.$route.meta && _vm.$route.meta.hideMenu
    }
  }, [_c('div', {
    staticClass: "menu-warp view-flex"
  }, [_c('div', {
    staticClass: "menu-scroll primary-nav"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": {
        path: _vm.path_prefixes ? '/' + _vm.path_prefixes : '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/image/logo-2.png"),
      "alt": "美好活法"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.matched[0].path ? _vm.$route.matched[0].path : _vm.$route.matched[1].path,
      "text-color": "var(--admin-nav-text)",
      "active-text-color": "var(--admin-nav-text)"
    },
    on: {
      "select": _vm.handleChange
    }
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.path
      },
      on: {
        "click": function($event) {
          return _vm.toRoute(item.path)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: 'iconfont icon-' + item.iconCls
    }), _vm._v(" " + _vm._s(item.name) + "\n            ")]) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-account"
  }, [_c('el-popover', {
    attrs: {
      "placement": "right-end",
      "trigger": "click",
      "width": 230,
      "popper-class": "sidebar-account-menu"
    },
    model: {
      value: (_vm.visible2),
      callback: function($$v) {
        _vm.visible2 = $$v
      },
      expression: "visible2"
    }
  }, [_c('div', {
    staticClass: "account-menu-heading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.nick_name || _vm.name || '当前账号'))]), _vm._v(" "), _c('span', [_vm._v("账号管理")])]), _vm._v(" "), _c('button', {
    staticClass: "account-menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.visible2 = false;
        _vm.handleUserInfo()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v("基础信息")]), _vm._v(" "), (_vm.$store.getters.login_type === 'distributor') ? _c('button', {
    staticClass: "account-menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.visible2 = false;
        _vm.handleClickSelectShop()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-office-building"
  }), _vm._v("切换店铺")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "account-menu-item",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.visible2 = false;
        _vm.reloadCache()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v("刷新首页缓存")]), _vm._v(" "), _c('button', {
    staticClass: "account-menu-item account-menu-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.visible2 = false;
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-switch-button"
  }), _vm._v("退出登录")]), _vm._v(" "), _c('button', {
    staticClass: "account-trigger",
    attrs: {
      "slot": "reference",
      "type": "button",
      "title": _vm.nick_name || _vm.name || '账号菜单',
      "aria-label": (_vm.nick_name || _vm.name || '当前账号') + '，账号菜单',
      "aria-haspopup": "true",
      "aria-expanded": _vm.visible2 ? 'true' : 'false'
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "account-icon el-icon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "account-name"
  }, [_vm._v(_vm._s(_vm.nick_name || _vm.name || '当前账号'))]), _vm._v(" "), _c('i', {
    staticClass: "account-arrow",
    class: _vm.visible2 ? 'el-icon-arrow-down' : 'el-icon-arrow-up',
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)], 1), _vm._v(" "), (_vm.$route.meta && !_vm.$route.meta.hideMenu) ? _vm._l((_vm.$router.options.routes), function(item, index) {
    return (_vm.isCurrentSubmenu(item.path)) ? _c('div', {
      staticClass: "menu-scroll secondary-nav"
    }, [_c('el-menu', {
      staticClass: "sub-menu",
      attrs: {
        "default-active": _vm.$route.matched.length > 3 ? _vm.$route.matched[_vm.$route.matched.length - 2].path : _vm.$route.path,
        "background-color": "#f5f6f8",
        "text-color": "var(--admin-text-regular)",
        "active-text-color": "var(--admin-text-primary)",
        "router": ""
      }
    }, [_vm._l((item.children), function(child, index) {
      return (!child.hidden) ? [(child.isLeaf) ? _c('el-menu-item-group', {
        staticClass: "menu-group"
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _vm._l((child.children), function(sub, index) {
        return [(!sub.hidden) ? _c('el-menu-item', {
          key: sub.path,
          attrs: {
            "index": sub.path
          }
        }, [_vm._v(_vm._s(sub.name))]) : _vm._e()]
      })], 2) : _c('div', {
        staticClass: "menu-group"
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))])], 1)] : _vm._e()
    })], 2)], 1) : _vm._e()
  }) : _vm._e()], 2)]), _vm._v(" "), _c('el-container', [_c('el-main', [_c('section', {
    staticClass: "content-container height-content",
    attrs: {
      "id": "container"
    }
  }, [_c('el-col', {
    staticClass: "content-wrapper height-content",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    staticClass: "height-content",
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "height-content"
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "管理员信息",
      "visible": _vm.dialogBaseInfo,
      "width": "40%",
      "before-close": _vm.handleBaseInfoClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogBaseInfo = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "账户"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.form.mobile) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "大头照"
    }
  }, [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.form.head_portrait,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), (_vm.change_pwd) ? [_c('el-form-item', {
    attrs: {
      "label": "修改密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": _vm.new_input_type,
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.pwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "pwd", $$v)
      },
      expression: "form.pwd"
    }
  }, [_c('i', {
    staticClass: "el-icon-view",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "suffix",
      "title": "隐藏密码"
    },
    on: {
      "click": _vm.changeNewPass
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认修改密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": _vm.input_type,
      "placeholder": "请输入确认密码"
    },
    model: {
      value: (_vm.form.repwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "repwd", $$v)
      },
      expression: "form.repwd"
    }
  }, [_c('i', {
    staticClass: "el-icon-view",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "suffix",
      "title": "隐藏密码"
    },
    on: {
      "click": _vm.changePass
    },
    slot: "suffix"
  })])], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-612f39c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/layout.vue
// module id = 972
// module chunks = 30